
import {
  defineComponent,
  useFetch,
  useMeta,
  useContext,
} from '@nuxtjs/composition-api';
import useCertificates from '~/composables/useCertificates';
import CertificatesMainSection from '~/domains/certificates/components/CertificatesMainSection';
import useAlternateLinks from '~/composables/useAlternateLinks';

export default defineComponent({
  components: { CertificatesMainSection },
  head: {},
  setup() {
    const { i18n } = useContext();
    const {
      SKUCategories,
      isLoading,
      mergeCertificatesIntoCategorySKU,
      fetchProductsSKUTree,
      fetchDocumentsByType,
    } = useCertificates();
    const { alternateLinks } = useAlternateLinks();

    useFetch(async () => {
      await fetchProductsSKUTree();
      await fetchDocumentsByType('Certificates');
      mergeCertificatesIntoCategorySKU();
    });

    useMeta({
      title: i18n.tc('certificate', 0),
      meta: [
        {
          property: 'og:title',
          content: i18n.tc('certificate', 0),
        },
      ],
      link: alternateLinks.value,
    });

    return {
      SKUCategories,
      isLoading,
    };
  },
});
